//TODO: update with yours
export interface InteractionConfig {
	msgFrom: string;
	prompt: string;
	// time after which the interaction gets hidden - in ms
	timeout?: number;
	websocketPayload: string;
}

//TODO: update with yours
export function validateConfig(c: InteractionConfig): boolean {
	if (!c) {
		return false;
	}
	if (!c.timeout) {
		c.timeout = Number(new URLSearchParams(window.location.search).get('timeout') || '5000');
	}
	return true;
}
